module.exports = __webpack_public_path__ + "static/media/loginMobile.1b756816.jpg";